/* eslint-disable react-refresh/only-export-components */
import axios from "axios";
import React, { createContext, useContext } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface ExtensionProvideProps {
  children: React.ReactNode;
}

interface ExtensionContentProps {
  CreateManualMediaKit: ({
    DEMOGRAPHICS,
    DISCOVERY,
    ENGAGEMENT,
    FOLLOWERS,
    TOPPOSTS,
  }: {
    DEMOGRAPHICS: any[];
    DISCOVERY: any[];
    ENGAGEMENT: any[];
    FOLLOWERS: any[];
    TOPPOSTS: any[];
  }) => Promise<any>;
}

const ExtensionContent = createContext<ExtensionContentProps | null>(null);
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const useExtension = () => {
  return useContext(ExtensionContent);
};

export const ExtensionProvider: React.FC<ExtensionProvideProps> = (props) => {
  const CreateManualMediaKit = async ({
    DEMOGRAPHICS,
    DISCOVERY,
    ENGAGEMENT,
    FOLLOWERS,
    TOPPOSTS,
  }: {
    DEMOGRAPHICS: any[];
    DISCOVERY: any[];
    ENGAGEMENT: any[];
    FOLLOWERS: any[];
    TOPPOSTS: any[];
  }) => {
    const result = await axios.post(
      `${host}/ext/save/fromxlsx/profile`,
      {
        DEMOGRAPHICS,
        DISCOVERY,
        ENGAGEMENT,
        FOLLOWERS,
        TOPPOSTS,
      },
      {
        headers: {
          jwtToken: localStorage.getItem("jwtToken"),
        },
      }
    );

    return result.data;
  };

  return (
    <ExtensionContent.Provider value={{ CreateManualMediaKit }}>
      {props.children}
    </ExtensionContent.Provider>
  );
};
